var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('StatsWidget7')],1),_c('div',{staticClass:"col-12"},[_c('ListWidget1')],1),_c('div',{staticClass:"col-12"},[_c('AdvancedTableWidget2')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }